export default {"src":"/_next/static/media/wine-spectator.11654772.svg","height":32,"width":115,"blurWidth":0,"blurHeight":0};